import { render } from "./GoogleRedirect.vue?vue&type=template&id=daf4c9c8"
import script from "./GoogleRedirect.vue?vue&type=script&lang=js"
export * from "./GoogleRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__